module.exports = __webpack_public_path__ + "img/rules-01.1056ffb4.svg";